<div class="drag-and-drop">
	Drag Email Here
</div>
